import { Link } from "react-router-dom";
import SignupForm from "../components/auth/SignupForm";
import "./SignupPage.css";

const FEATURE_POINTS = [
  "AI-tailored hashtag sets for every post",
  "Audience goals, tone, and niche captured in minutes",
  "Save bundles, compare performance, and share with your team",
];

export default function SignupPage() {
  return (
    <div className="signup-page">
      <div className="signup-page__inner">
        <div className="signup-page__content">
          <span className="signup-page__eyebrow">Start for free</span>
          <h1 className="signup-page__title">Launch your 14-day ChicLogic.io trial</h1>
          <p className="signup-page__subtitle">No credit card required. Cancel anytime. Unlock advanced hashtag insights with premium AI workflows.</p>

          <ul className="signup-page__list">
            {FEATURE_POINTS.map((item) => (
              <li key={item}>
                <span className="signup-page__check" aria-hidden="true">✔</span>
                <span>{item}</span>
              </li>
            ))}
          </ul>

          <p className="signup-page__footer">
            Already have an account? <Link to="/login">Sign in</Link>
          </p>
        </div>

        <div className="signup-page__form">
          <SignupForm />
        </div>
      </div>
    </div>
  );
}
